import React from "react";
import PropTypes from "prop-types";
import { Dimmer, Header, Image } from "semantic-ui-react";
import { MSG_LOADING_GENERICO } from "../infrastructure/appConstants";

const LoadingComponent = ({ inverted, content, showContent }) => (
  <Dimmer active inverted>
    <Image src="/assets/icons/loading/hourglass.svg" centered size="small" />
    <Header as="h2">
      <Header.Subheader>
        {content && showContent && showContent === true
          ? content
          : MSG_LOADING_GENERICO}
      </Header.Subheader>
    </Header>
  </Dimmer>
);

LoadingComponent.propTypes = {
  inverted: PropTypes.bool,
  content: PropTypes.string,
  showContent: PropTypes.bool,
};

LoadingComponent.defaultProps = {
  inverted: false,
};

export default LoadingComponent;
